import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Menu, Space, Typography } from 'antd'

import {
  accountDetails,
  addressesList,
  ordersList,
  ordersListLinkedAccounts,
  prescriptionDetails,
  pupillaryDistanceDetails,
} from 'src/routes/NamedRoutes'

import './Navbar.less'
import { useRecoilValue } from 'recoil'
import { authenticatedCustomerState } from 'src/data/customers/CustomersAtoms'

const Navbar = (): JSX.Element => {
  const customer = useRecoilValue(authenticatedCustomerState)
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <Space direction="vertical" size="small">
      <Typography.Text className="font-lora--18 navbar__subtitle">
        {t('common:text.manage_account')}
      </Typography.Text>

      <Menu
        mode="inline"
        inlineIndent={10}
        className="navbar__menu"
        selectedKeys={location.pathname.split('/')}
      >
        <Menu.Item
          className="navbar__menu-item"
          key="profile"
          icon={<ArrowRightOutlined />}
        >
          <Link to={accountDetails}>{t('common:navigation.profile')}</Link>
        </Menu.Item>
        <Menu.Item
          className="navbar__menu-item"
          key="orders"
          icon={<ArrowRightOutlined />}
        >
          <Link to={customer.has_child ? ordersListLinkedAccounts.replace(':customerId', `${customer.id}`) : ordersList}>{t('common:navigation.recent_orders')}</Link>
        </Menu.Item>
        {
          customer.has_child &&
          <Menu
            mode="inline"
            inlineIndent={10}
            className="navbar__menu"
            selectedKeys={[location.pathname]}
          >
            <Menu.Item
              className="navbar__menu-item__orders"
              key={`/linked-accounts/${customer.id}/orders`}
              icon={<ArrowRightOutlined />}
              style={{ paddingLeft: '10px' }}
            >
              <Link to={ordersListLinkedAccounts.replace(':customerId', `${customer.id}`)}>{t('common:navigation.recent_orders_linked_accounts', { name: customer.first_name ?? customer.full_name })}</Link>
            </Menu.Item>
            {customer.children.map((child) => <Menu.Item
              className="navbar__menu-item__orders"
              key={`/linked-accounts/${child.id}/orders`}
              icon={<ArrowRightOutlined />}
              style={{ paddingLeft: '10px' }}
            >
              <Link to={ordersListLinkedAccounts.replace(':customerId', `${child.id}`)}>{t('common:navigation.recent_orders_linked_accounts', { name: child.first_name ?? child.full_name })}</Link>
            </Menu.Item>
            )}
          </Menu>
        }
        <Menu.Item
          className="navbar__menu-item"
          key="addresses"
          icon={<ArrowRightOutlined />}
        >
          <Link to={addressesList}>
            {t('common:navigation.saved_addresses')}
          </Link>
        </Menu.Item>

        <Menu.Item
          className="navbar__menu-item"
          key="prescription"
          icon={<ArrowRightOutlined />}
        >
          <Link to={prescriptionDetails}>
            {t('common:navigation.prescription')}
          </Link>
        </Menu.Item>
        <Menu.Item
          className="navbar__menu-item"
          key="pupillary-distance"
          icon={<ArrowRightOutlined />}
        >
          <Link to={pupillaryDistanceDetails}>
            {t('common:navigation.pupillary_distance')}
          </Link>
        </Menu.Item>
      </Menu>
    </Space>
  )
}

export default Navbar
